import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import ReactStars from "react-rating-stars-component";
import google from "../../images/google_reviews_logo.svg";
import axios from "../../util/axiosInst";
import Image from "../Image";

const ProfileTab = ({ providerDetail: { googlePlaceId, userId } }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (userId) {
      axios
        .get(`v1/provider/reviews/${userId}`)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.isReviewsFound) {
              setData(res.data.data);
            }
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          setError(true);
        });
    }
  }, [userId]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center fw-bold fs-5 mx-5">
        Please wait retrieving the reviews. If it takes longer time then
        please refresh the page and retry.
      </div>
    );
  }

  if (!data.reviews || data.reviews.length === 0) {
    return <p className="text-center">No Reviews Found</p>;
  }

  return (
    <div className="p-4 container bg-muted-25 p-md-5 mt-4 p-1 card-scroll">
      <div className="row mb-3 bg-white rounded-1">
        <div className="col-12 pt-md-0 pt-4">
          <div className="d-md-flex row py-md-3 px-0 mb-4 rounded">
            <div className="col-md-6 col-7 d-md-flex d-block">
              <Image
                local={true}
                src={google}
                className="w-75 d-md-block d-none mt-2 height-80"
                alt="Google"
              />
              <Image
                local={true}
                src={google}
                className="w-100 d-md-none d-block"
                alt="Google"
              />
            </div>
            {googlePlaceId && data.rating && (
              <div className="col-md-6 col-4 d-md-flex d-none pt-md-3 justify-content-end flex-grow-1 align-items-center pe-md-4 mt-md-0">
                <a
                  className="btn btn-outline-primary bg-primary fs-5 text-white fw-semibold py-2 margintop--10px"
                  href={`https://search.google.com/local/writereview?placeid=${googlePlaceId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Write a Review
                </a>
              </div>
            )}
          </div>
          {data.reviews &&
            data.reviews.map((review, idx) => (
              <div className="col-md-11 col-8" key={idx}>
                <div className="d-flex row justify-content-between mb-2">
                  <div className="me-3 col-md-8 col-12">
                    <div className="d-flex col-12 align-self-center">
                      <div className="d-md-flex d-block">
                        <h5 className="me-2 pt-3 fw-semibold">
                          {review.author_title || ""}
                        </h5>
                        <div className="pt-md-2">
                          <ReactStars
                            count={5}
                            edit={false}
                            isHalf={true}
                            value={review.review_rating || 0}
                            size={24}
                            activeColor="#ffd700"
                          />
                        </div>
                      </div>
                    </div>
                    <p className="mb-0 small text-black">
                      {review.review_text || ""}
                    </p>
                    {review.owner_answer && (
                      <div className="col-sm-11 border-start ms-3 ps-2 border-secondary my-3 offset-sm-1">
                        <p className="text-black fs-6">
                          {review.owner_answer}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          {data.reviewLink && (
            <div className="text-center mt-5">
              <a href={data.reviewLink} target="_blank" rel="noopener noreferrer">
                <button
                  type="button"
                  className="jump-button btn btn-light btn-lg bg-primary text-center rounded-pill border-0 fs-16 text-white padding-12px-35px"
                >
                  Click here to see more reviews
                </button>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileTab;